/**
 * TODO: Please deprecate this.
 */
import {
	DND_OPERATION_CARD_PARENT_SET,
	DND_OPERATION_CARD_PARENT_UNSET,
} from '../../../../../../common/constants.tsx';
import type { DndOperation } from '../../../../../../common/types.tsx';
import {
	cancelBacklogPanelEpicAssignInteraction,
	setBacklogPanelEpicAssignInteractionStartMark,
	stopBacklogPanelEpicAssignInteraction,
} from '../../../../../../services/performance/metrics-interaction-epic-assign/index.tsx';
import {
	cancelBacklogPanelEpicUnassignInteraction,
	setBacklogPanelEpicUnassignInteractionStartMark,
	stopBacklogPanelEpicUnassignInteraction,
} from '../../../../../../services/performance/metrics-interaction-epic-unassign/index.tsx';

type MutationUtilsProps = {
	setStartInteraction: () => void;
	setStopInteraction: (isCompanyManaged: boolean) => void;
	setCancelInteraction: () => void;
	dndOperation: DndOperation;
	errorLogId: string;
	errorLogMessage: string;
};

export const assignEpicUtils: MutationUtilsProps = {
	setStartInteraction: setBacklogPanelEpicAssignInteractionStartMark,
	setStopInteraction: stopBacklogPanelEpicAssignInteraction,
	setCancelInteraction: cancelBacklogPanelEpicAssignInteraction,
	dndOperation: DND_OPERATION_CARD_PARENT_SET,
	errorLogId: 'epic-assign.failure',
	errorLogMessage: 'Failed to assign an epic',
};

export const unassignEpicUtils: MutationUtilsProps = {
	setStartInteraction: setBacklogPanelEpicUnassignInteractionStartMark,
	setStopInteraction: stopBacklogPanelEpicUnassignInteraction,
	setCancelInteraction: cancelBacklogPanelEpicUnassignInteraction,
	dndOperation: DND_OPERATION_CARD_PARENT_UNSET,
	errorLogId: 'epic-unassign.failure',
	errorLogMessage: 'Failed to unassign an epic',
};
